define('HomeFeaturedProducts.Slider.View', [
	'Backbone.CollectionView',
	'Backbone',
	'home_featured_products_cell.tpl',
	'home_featured_products_row.tpl',
	'home_featured_products_slider.tpl',
	'HomeFeaturedProducts.Product.View',
	'Item.Collection',
	'Item.Model',
	'jQuery',
	'Profile.Model',
	'SC.Configuration',
	'underscore',
	'Utils'
], function HomeFeaturedProductsSliderView(
	BackboneCollectionView,
	Backbone,
	homeFeaturedProductsCellTpl,
	homeFeaturedProductsRowTpl,
	homeFeaturedProductsSliderTpl,
	HomeFeaturedProductsProductView,
	ItemCollection,
	ItemModel,
	jQuery,
	Profile,
	Configuration,
	_,
	Utils
) {
	'use strict';

	return BackboneCollectionView.extend({
		actualFilter: 'all',
		sliderInstance: null,
		initialize: function initialize(options) {
			var self = this;
			var profile = Profile.getInstance();
			var store = profile.get('store');
			var storeName = (store && store.get('name')) ? store.get('name') : null;
			var filterAll = { type: 'all', name: 'All' };
			var collectionData = {
				data: {
					sort: 'custitem_sorting_sales:desc',
					fieldset: options.config.fieldset || 'merchandising'
				}
			};

			if (storeName && options.config.applyFilterByStore) {
				collectionData.data.custitem_awa_show_on_home_by_store = storeName.replace(/ /g, '-');
			} else {
				collectionData.data.custitem_home_featured_item = 'T';
			}

			this.collection = new ItemCollection();
			this.collection.fetch(collectionData);

			this.application = options.application;
			this.config = options.config;
			this.filters = this.config.filters || [];

			BackboneCollectionView.prototype.initialize.call(this, {
				collection: self.collection,
				viewsPerRow: Infinity,
				cellTemplate: homeFeaturedProductsCellTpl,
				rowTemplate: homeFeaturedProductsRowTpl,
				childView: HomeFeaturedProductsProductView,
				template: homeFeaturedProductsSliderTpl
			});

			Backbone.Events.on('HomeFeaturedFilterChange', jQuery.proxy(this, 'applyFilter'));

			this.baseCollection = this.collection.clone();
			this.collection.on('sync', function onSync() {
				self.baseCollection = self.collection.clone();
				self.collection.models = self.filterChildItems(self.collection.models);
				self.render();
			});
		},
		initSlider: function initSlider() {
			var sliderConfig = this.application.getConfig('bxSliderDefaults', {});
			var carousel = this.$el.find('[data-type="featured-products-carousel"]');
			var self = this;
			var featureProductsConfig = {
				minSlides: parseInt(this.config.minSlides, 10) || 2,
				maxSlides: parseInt(this.config.maxSlides, 10) || 3,
				slideWidth: parseFloat(this.config.slideWidth) || 413.3333333333,
				infiniteLoop: false,
				nextText: this.config.nextText,
				prevText: this.config.prevText,
				onSliderLoad: function onSlideBefore() {
					featureProductsConfig.onSlideBefore(null, 0, 0);
					jQuery('[data-view=ProductSlider]').css('minHeight', self.$('.item-relations-related-row').height());
				},
				onSlideBefore: function onSlideBefore($se, oi, newIndex) {
					var startIndex = (newIndex * 3);
					var $slide;
					var $slideLinks = carousel.find('.home-featured-products-title');
					$slideLinks.attr('tabindex', '-1');
					for (var i = 0; i < 3; i++) {
						$slide = jQuery($slideLinks.get(i + startIndex));
						$slide.attr('tabindex', '0');
					}
				}
			};

			sliderConfig = _.extend({}, sliderConfig, featureProductsConfig);
			this.sliderInstance = carousel;
			Utils.initBxSlider(carousel, sliderConfig);
		},
		applyFilter: function applyFilter(filter) {
			var collection = this.baseCollection.clone();
			var self = this;

			if (filter.type === 'all') {
				filter = null;
			}

			if (filter) {
				this.collection = collection.reset(collection.filter(function filterCollection(model) {
					return model.get(filter.field);
				}));
				this.collection = this.filterChildItems(this.collection);
			} else {
				this.actualFilter = 'all';
				this.collection = this.filterChildItems(collection.models);
			}
			self.render();
		},
		filterChildItems: function filterChildItems(models) {
			var newModels = [];
			var childrensToShow;
			var newModel;
			var posibleOptions;
			var childOption;
			var opt;

			_.each(models, function each(model) {
				childrensToShow = _.where(model.get('matrixchilditems_detail'), {
					custitem_include_in_merch: true
				});
				if (childrensToShow.length) {
					_.each(childrensToShow, function eachChild(child) {
						newModel = new ItemModel(model.attributes);
						newModel.set({
							_name: child.displayname,
							onlinematrixpricerange: null,
							merchantChild: true,
							internalid: child.internalid
						});
						posibleOptions = newModel.getPosibleOptions();
						_.each(posibleOptions, function eachOption(option) {
							childOption = child[option.itemOptionId];
							if (childOption) {
								opt = _.findWhere(option.values, {
									label: childOption
								});
								if (opt && opt.internalid) {
									newModel.setOption(option.cartOptionId, opt.internalid);
								}
							}
						});
						newModels.push(newModel);
					});
				} else {
					newModels.push(model);
				}
			});
			return newModels;
		},
		render: function render() {
			var self = this;
			BackboneCollectionView.prototype.render.apply(this, arguments);
			_.defer(function defer() {
				try {
					self.sliderInstance.destroySlider();
				} catch (e) {
					// console.log(e);
				}
				self.initSlider();
			});
		},
		getContext: function getContext() {
			var activeType = 'all';
			_.each(this.filters, function each(filter) {
				if (filter.type === self.actualFilter) {
					filter.active = true;
					activeType = filter.type;
				}
			});
			return {
				filters: this.filters,
				activeType: activeType
			};
		}
	});
});
